var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopytlink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.962 11.186a.596.596 0 0 1-.257-.05 3.625 3.625 0 0 1-1.898-1.64c-.989-1.78-.376-4.103 1.354-5.18l2.313-1.434a3.584 3.584 0 0 1 2.798-.434c.949.247 1.75.87 2.233 1.74.989 1.778.376 4.101-1.354 5.179l-.257.188a.751.751 0 0 1-1.038-.168.751.751 0 0 1 .168-1.038l.307-.218c1.107-.692 1.483-2.125.88-3.222A2.118 2.118 0 0 0 7.906 3.88a2.058 2.058 0 0 0-1.641.257L3.952 5.57c-1.068.662-1.443 2.096-.84 3.203.247.445.642.79 1.117.968a.728.728 0 0 1 .435.95.742.742 0 0 1-.702.494z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.628 13.548c-.297 0-.603-.04-.9-.118a3.542 3.542 0 0 1-2.224-1.74c-.988-1.78-.375-4.102 1.354-5.18l.257-.187a.751.751 0 0 1 1.038.168c.238.336.158.8-.168 1.037l-.306.218c-1.107.692-1.483 2.125-.88 3.222.287.514.751.88 1.305 1.028.553.149 1.137.06 1.64-.257l2.314-1.433c1.067-.662 1.443-2.095.84-3.203a2.144 2.144 0 0 0-1.117-.968.728.728 0 0 1-.435-.95.731.731 0 0 1 .949-.434c.8.296 1.473.88 1.898 1.64.988 1.78.376 4.103-1.354 5.18l-2.313 1.434a3.638 3.638 0 0 1-1.898.543z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopytlink);
export default __webpack_public_path__ + "static/media/copytlink.2df700f47a40bf627965670cf8180ae2.svg";
export { ForwardRef as ReactComponent };